const ua = window.navigator.userAgent.toLowerCase();

const Environment = {
    android: /android/.test(ua),
    ie: /msie/.test(ua) || (!window.ActiveXObject && ('ActiveXObject' in window)),
    ios: /ip(ad|hone|od)/.test(ua),
    touch: ('ontouchstart' in window || !!window.navigator.msMaxTouchPoints),
    winphone: /windows phone/.test(ua)
};

Environment.mobile = !!(Environment.android || Environment.ios || Environment.winphone);


export default Environment;



// WEBPACK FOOTER //
// ./src/common/utils/environment.js